export const IMG = {
  basement: "https://images.unsplash.com/photo-1646184466560-f81b1e495604?crop=entropy&cs=srgb&fm=jpg&q=80&w=600",
  room: "https://images.unsplash.com/photo-1590354524503-752b2b23955c?fm=jpg&w=600&q=80",
  truck: "https://images.unsplash.com/photo-1787630551590-48debd4bd588?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
};

export const Container = ({ children, className = "" }) => (
  <div className={`mx-auto w-full max-w-6xl px-5 sm:px-8 ${className}`}>{children}</div>
);

export const Eyebrow = ({ children }) => (
  <p className="text-xs font-bold uppercase tracking-[0.2em] text-[color:var(--brand)]">{children}</p>
);

export const SectionTitle = ({ children, className = "" }) => (
  <h2 className={`font-display text-3xl font-extrabold leading-tight tracking-tight text-slate-900 sm:text-4xl ${className}`}>{children}</h2>
);

export const Logo = () => (
  <span className="font-display text-xl font-extrabold tracking-tight text-slate-900">
    Squad<span className="text-[color:var(--brand)]">rum</span>
  </span>
);
